import { render, staticRenderFns } from "./channelClassification.vue?vue&type=template&id=3577b49d&scoped=true&"
import script from "./channelClassification.vue?vue&type=script&lang=js&"
export * from "./channelClassification.vue?vue&type=script&lang=js&"
import style0 from "./channelClassification.vue?vue&type=style&index=0&id=3577b49d&prod&scoped=true&lang=css&"
import style1 from "./channelClassification.vue?vue&type=style&index=1&id=3577b49d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3577b49d",
  null
  
)

export default component.exports